/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const collectionStatsSchema = z.object({
  collectionId: z.number(),
  name: z.string(),
  posterUrl: z.string().nullable().optional(),
  totalPassed: z.number(),
  totalFailed: z.number(),
  totalSkipped: z.number(),
  totalTimeSpent: z.number(),
});

export type ICollectionStats = z.infer<typeof collectionStatsSchema>;
